export default class HoverMaskContainer
{

  constructor() {

    this.items = [];
    this.hovering = null;

  }

  static instance() {
    return instance;
  }

  push(item) {
    this.items.push(item);
  }

  debug(ctx) {

    this.items.forEach(item => {
      item.debug(ctx);
    });

  }

  sortItems() {
    return this.items.sort((a, b) => {

      if (a.isStatic === b.isStatic) {
        return 0;
      }

      if (a.isStatic && !b.isStatic) {
        return 1;
      }

      return -1;

    });
  }

  mouseMove(x, y) {
    this.sortItems();
    let i = this.items.length;

    while(i--) {

      let mask = this.items[i];
      let item = mask.mouseMove(x, y);

      if (item) {

        if (this.hovering) {

          if (this.hovering === item) {

            // we're already hovering, return true and quit quietly, unless the repeated property is true

            if (this.hovering.repeated) {
              this.hovering.callOver(x, y);
            }

            if (this.hovering.disableCursor) {
              return false;
            }

            return true;

          }

          // we're hovering something else. Call OUT() on the current element
          this.hovering.callOut();

        }

        // register (new) hover and call its IN() function
        this.hovering = item;
        this.hovering.callOver(x, y);
        return true;

      }

    }

    if (this.hovering) {
      this.hovering.callOut();
      this.hovering = null;
    }

  }

  click(x, y) {
    let items = this.sortItems();

    let i = items.length;

    while(i--) {

      let mask = items[i];
      let result = mask.click(x, y);

      if (typeof result === 'boolean') {
        return result;
      }

    }

  }

  garbageCollect() {
    this.items.forEach((item, index, object) => {
      object.splice(index, 1);
    })
  }
}

let instance = new HoverMaskContainer();
